export const getTextWithoutChildren = $node =>
    [ ...$node[0].childNodes ]
        .filter(node => node.nodeType === 3)
        .map(node => node.nodeValue.trim())
        .join(' ')
        .trim();
